enum MediaTypes {
  BrandVideo = 'brandVideo',
};

export default MediaTypes;
